module.exports = __webpack_public_path__ + "img/so.26a607c6.svg";